import React, { Component } from 'react';
import TablaHistorialIntentos from './TablaHistorialIntentos';

class ModalLogIntentos extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { titulo, mensajePrincipal, mensajeSecundario, value, nombreCampo } = this.props;
        //Si el array de intentos tiene mas de 3 registros se debe agregar la clase del scroll
        let claseLogIntentosScroll = this.props.datosLogIntentos.length > 3 ? " modalLogIntentosScroll" : "";
        return ( 
            <div className='modalContainerLogIntentos'>
                <div>
                    <div className="arrow-up" />
                    <div className="modal-content z-index-999">
                        <div className="modal-header-Datos-Cuenta">
                            <div className="close-Datos-Cuenta" data-dismiss="modal" aria-hidden="true">
                                <label onClick={() => this.props.openModal(3,null,undefined,false)} className="ti-close clickable"></label>
                            </div>
                            <h2 className="modal-title-Log-Intentos">{"Log de Intentos"}</h2>
                        </div>
                        <div className={"modal-body" + claseLogIntentosScroll}>
                            <TablaHistorialIntentos datosLogIntentos={this.props.datosLogIntentos}></TablaHistorialIntentos><br/>
                            <span className="fontDatosCuenta paddingLeftXS paddingTopBottom">
                                Si el inconveniente persiste, contáctese con <strong>Soporte Técnico </strong> y tenga disponible la información de este log para identificar
                                el caso.
                            </span>
                        </div>
                    </div>
                </div>
            </div> 
        );
    }
}

export default ModalLogIntentos;   